import { routes } from '../constants/routes';

import { getEnvVar } from './getEnvVar';

/**
 * Returns true, if user is on tenant-less cloud.openvpn.com page
 */
export function getIsCloudPortal(url: string): boolean {
    if (typeof url !== 'string') {
        return false;
    }

    return url.includes('https://cloud.') || url.includes('http://cloud.');
}

/**
 * Returns tenant-less url
 * e.g. cloud.openvpn-env.com
 */
export function getCloudPortalUrl(): string {
    return getEnvVar('ROOT_UI');
}

/**
 * Changes URL address by injecting tenant token instead of `cloud` subdomain
 * @param {string} href url address
 * @param {string} tokenTenant tenant token
 * @returns {string} modified url address
 */
export function replaceCloudTenant(href: string, tokenTenant: string): string {
    return href.replace('cloud.', `${tokenTenant}.`);
}

export function getPureTenantUrl(tenant: string): string {
    return replaceCloudTenant(getCloudPortalUrl(), tenant);
}

export function isForbiddenTenantReached(): boolean {
    return window.location.hash === '#forbidden';
}

export function getForbiddedTenantUrl(): string {
    return `${getCloudPortalUrl() + routes.tenants}#forbidden`;
}
